import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { handlers } from '../../helpers/helpers';
import RadioType from './answerTypes/RadioType';
import SelectType from './answerTypes/SelectType';
import TextAreaType from './answerTypes/TextAreaType';
import DateType from './answerTypes/DateType';
import TimeType from './answerTypes/TimeType';

const EditAnswer = ({ editAnswerData, setStep }) => {
  const [question, setQuestion] = useState();

  const filterQuestion = () => {
    const _tests = JSON.parse(localStorage.getItem('userData')).tests;
    const filterByTestId = _tests.filter((test) => test.id === editAnswerData.testId);
    const filterByGroupId = filterByTestId[0].groups.filter((group) => group.id === editAnswerData.groupId);
    const filterByQuestion = filterByGroupId[0].questions.filter((question) => question.question_id === editAnswerData.questionId);
    const totalQuestions = filterByGroupId[0].questions.length;
    const questionIndex = filterByGroupId[0].questions.indexOf(filterByQuestion[0]) + 1;
    const questionType = filterByQuestion[0].type;
    let questionOptions;
    if (questionType !== 'textArea' && questionType !== 'text') {
      questionOptions = filterByQuestion[0].options;
    }

    handlers.handleUserData({
      questionDataToEdit: {
        questionId: editAnswerData.questionId,
        testId: editAnswerData.testId,
        groupId: editAnswerData.groupId,
        groupName: editAnswerData.groupName,
        questionIndex,
        questionTitle: editAnswerData.questionTitle,
        questionType,
        totalQuestions,
        questionOptions,
        selectedAnswer: editAnswerData.answer,
      },
    });

    setQuestion({
      questionId: editAnswerData.questionId,
      testId: editAnswerData.testId,
      groupId: editAnswerData.groupId,
      groupName: editAnswerData.groupName,
      questionIndex,
      questionTitle: editAnswerData.questionTitle,
      questionType,
      totalQuestions,
      questionOptions,
      selectedAnswer: editAnswerData.answer,
    });
  };

  const onChange = (testId, groupId, questionId, selectedAnswer) => {
    setQuestion({
      questionId: question.questionId,
      testId: question.testId,
      groupId: question.groupId,
      groupName: question.groupName,
      questionIndex: question.questionIndex,
      questionTitle: question.questionTitle,
      questionType: question.questionType,
      totalQuestions: question.totalQuestions,
      questionOptions: question.questionOptions,
      selectedAnswer: selectedAnswer,
    });
    handlers.handleUserData({
      questionDataToEdit: {
        questionId: question.questionId,
        testId: question.testId,
        groupId: question.groupId,
        groupName: question.groupName,
        questionIndex: question.questionIndex,
        questionTitle: question.questionTitle,
        questionType: question.questionType,
        totalQuestions: question.totalQuestions,
        questionOptions: question.questionOptions,
        selectedAnswer: selectedAnswer,
      },
    });
    handlers.handleModifyAnswer({
      testId: testId,
      groupId: groupId,
      questionId: questionId,
      selectedAnswer: selectedAnswer,
    });
    setStep(2);
  };

  useEffect(() => {
    filterQuestion();
  }, []);

  return (
    <Row justify="center" className="question-container mt-80">
      {question && (
        <Col lg={22} md={22}>
          <Row justify="space-between">
            <Col>
              <p>{question.groupName && question.groupName}</p>
            </Col>
            <Col>
              <p>
                Pregunta {question.questionIndex && question.questionIndex} de {question.totalQuestions}
              </p>
            </Col>
          </Row>
          {question.questionType === 'radio' && <RadioType question={question} onChange={onChange} onEdit={function () {}} />}
          {['select', 'select_multiple'].includes(question.questionType) && (
            <SelectType question={question} onChange={onChange} onEdit={function () {}} isMultiple={question.questionType === 'select_multiple'} />
          )}
          {(question.questionType === 'textArea' || question.questionType === 'text') && (
            <TextAreaType question={question} onChange={onChange} onEdit={function () {}} />
          )}
          {question.questionType === 'date' && <DateType question={question} onChange={onChange} onEdit={function () {}} />}
          {question.questionType === 'time' && <TimeType question={question} onChange={onChange} onEdit={function () {}} />}
        </Col>
      )}
    </Row>
  );
};

export default EditAnswer;
